import memoize from 'lodash/memoize';

import {
    NODE_NAME_FIRST_NAME,
    NODE_NAME_LAST_NAME,
    NODE_NAME_EMAIL,
    NODE_NAME_ATTENDING,
    NODE_NAME_ADDITIONAL_GUEST_COUNT,
    NODE_NAME_CHECK_IN,
    NODE_NAME_CHECK_OUT,
    NODE_NAME_CC_EMAIL,
    NODE_NAME_BCC_EMAIL,
    NODE_NAME_ADDITIONAL_GUEST_FN_REGEXP,
    NODE_NAME_ADDITIONAL_GUEST_LN_REGEXP,
    NODE_NAME_ADDITIONAL_GUEST_EMAIL_REGEXP,
} from 'common/entities/formNode/nodeNames';

import {
    FIRST_NAME_LABEL,
    LAST_NAME_LABEL,
    EMAIL_LABEL,
    ATTENDING_LABEL,
    ADDITIONAL_GUEST_FIRST_NAME_LABEL,
    ADDITIONAL_GUEST_LAST_NAME_LABEL,
    ADDITIONAL_GUEST_EMAIL_LABEL,
    ADDITIONAL_GUEST_COUNT_LABEL,
    CHECK_IN_LABEL,
    CHECK_OUT_LABEL,
    CC_EMAIL_LABEL,
    BCC_EMAIL_LABEL,
} from '../constants/reservedInputNameLabels';

const nodeNamesToLabels = {
    [NODE_NAME_FIRST_NAME]: FIRST_NAME_LABEL,
    [NODE_NAME_LAST_NAME]: LAST_NAME_LABEL,
    [NODE_NAME_EMAIL]: EMAIL_LABEL,
    [NODE_NAME_ATTENDING]: ATTENDING_LABEL,
    [NODE_NAME_ADDITIONAL_GUEST_COUNT]: ADDITIONAL_GUEST_COUNT_LABEL,
    [NODE_NAME_CHECK_IN]: CHECK_IN_LABEL,
    [NODE_NAME_CHECK_OUT]: CHECK_OUT_LABEL,
    [NODE_NAME_CC_EMAIL]: CC_EMAIL_LABEL,
    [NODE_NAME_BCC_EMAIL]: BCC_EMAIL_LABEL,
};

const nodeNameRegExpsAndLabels = [
    {
        regExp: NODE_NAME_ADDITIONAL_GUEST_FN_REGEXP,
        label: ADDITIONAL_GUEST_FIRST_NAME_LABEL,
    },
    {
        regExp: NODE_NAME_ADDITIONAL_GUEST_LN_REGEXP,
        label: ADDITIONAL_GUEST_LAST_NAME_LABEL,
    },
    {
        regExp: NODE_NAME_ADDITIONAL_GUEST_EMAIL_REGEXP,
        label: ADDITIONAL_GUEST_EMAIL_LABEL,
    },
];

/**
 * @param {string} nodeName
 * @return {string|undefined}
 */
const getReservedInputNameLabel = (nodeName) => {
    if (nodeNamesToLabels[nodeName] !== undefined) {
        return nodeNamesToLabels[nodeName];
    }

    const { label } = nodeNameRegExpsAndLabels.find(({ regExp }) => regExp.test(nodeName)) || {};
    if (label !== undefined) {
        return label;
    }

    return undefined;
};

// This is a pure function. Memoizing so that we avoid inner loops on every render.
export default memoize(getReservedInputNameLabel);
